<template>
  <div :style="{ backgroundImage: 'url(' + imageurl + ')' }" class="homepage-block-container">
    <h3>{{ title }}</h3>
    <h4>{{ description }}</h4>
    <div class="button-container">
      <a
        :href="buttonData[0].buttonLink"
        role="button"
        :target="buttonData[0].buttonTarget"
        @click="homedatalayer()"
      >
        <strong>{{ buttonData[0].buttonText }}</strong>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home-page-block',
  props: {
    buttonData: {
      type: Array,
      required: false,
    },
    imageurl: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  methods: {
    homedatalayer() {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'home page',
        eventAction: `select::${this.title}`,
        eventLabel: `${this.buttonData[0].buttonText}::${this.buttonData[0].buttonLink}`,
        ecommerce: 'undefined',
        event_name: 'body_button_click',
        module_name: this.title,
        cta_name: this.buttonData[0].buttonText,
        link_url: this.buttonData[0].buttonLink,
      });
    },
  },
};
</script>
